import React from "react";
import { Link } from "react-router-dom";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomeBlogSection = ({ posts = [] }) => (
    <section data-testid={SITE.homeBlogPreview} className="py-14 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                <div className="max-w-2xl">
                    <p className="font-accent text-xs text-terracotta">STORIES &amp; NEWS</p>
                    <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                        From the journal
                    </h2>
                </div>
                <CtaButton to="/blog" variant="secondary">
                    Read the blog
                </CtaButton>
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
                {posts.map((p) => (
                    <Link
                        key={p.slug}
                        to={`/blog/${p.slug}`}
                        data-testid={SITE.blogCard}
                        className="group rounded-2xl overflow-hidden bg-white/80 border border-border/80 hover:-translate-y-0.5 transition-transform"
                    >
                        <div className="relative aspect-[16/10] overflow-hidden bg-sand">
                            <img
                                src={p.cover_image}
                                alt={p.title}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                        </div>
                        <div className="p-5">
                            <div className="flex items-center gap-2 text-xs text-foreground/60">
                                <span className="rounded-full bg-sand px-2 py-0.5 text-moss">
                                    {p.category}
                                </span>
                                <span>&middot;</span>
                                <span>{p.read_time}</span>
                            </div>
                            <h3 className="mt-2 font-display text-lg text-moss leading-snug">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-sm text-foreground/70 line-clamp-3">
                                {p.excerpt}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export default HomeBlogSection;
